'use client';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as React from 'react';
import { TabsListProps } from './types';

import c from 'classnames';

function TabsRoot({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={c('block w-full min-w-0', className)}
      {...props}
    />
  );
}

function TabsList({ className, ariaLabel, ...props }: TabsListProps) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={c(
        'flex w-full min-w-0 items-center gap-x-4 border-b border-grey-300 px-0',
        className
      )}
      aria-label={ariaLabel}
      {...props}
    />
  );
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  const tabTriggerBase =
    'relative inline-flex -mb-px px-2 py-3 text-[16px] font-normal leading-[24px] tracking-[-0.096px]';
  const tabTriggerColors =
    'text-grey-700 data-[state=active]:text-zinc-900 dark:hover:text-gray-300';
  const tabTriggerAfter =
    "after:absolute after:bottom-[0px] after:left-0 after:right-0 after:h-0.5 after:bg-blue after:opacity-0 after:content-[''] data-[state=active]:after:opacity-100";

  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={c(
        tabTriggerBase,
        tabTriggerColors,
        tabTriggerAfter,
        className
      )}
      {...props}
    />
  );
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={c(
        'w-full pt-8 text-left data-[state=inactive]:hidden',
        className
      )}
      {...props}
    />
  );
}
export { TabsContent, TabsList, TabsRoot, TabsTrigger };
